import React, { useEffect, useState } from "react";
import {
  EmailModal,
  OfferingContentContainer,
  OfferingSidebar,
} from "../components";
import { useAppStore } from "../data/AppStore";
import "./Offering.scss";
import { shallow } from "zustand/shallow";
import { useNavigate, useParams } from "react-router-dom";
import { logger } from "../utilities";
import { prepMessageSend } from "../api/messageService";

const LOG_PREFIX = "[Offering.js]";

const Offering = (props) => {
  const [state, _setState] = useState({
    emailOfferingList: [],
    emailModal: false,
    sentOfferings: false,
    isLoading: false,
    currentOffering: null,
  });
  const setState = (newState) => _setState(Object.assign({}, state, newState));
  const {
    currentOffering,
    emailOfferingList,
    emailModal,
    sentOfferings,
    isLoading,
  } = state;
  const [OFFERINGS, CLIENT, COMPANY, CART] = useAppStore(
    (state) => [state.OFFERINGS, state.CLIENT, state.COMPANY, state.CART],
    shallow
  );
  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    // Ensure OFFERINGS is an array before trying to find
    if (Array.isArray(OFFERINGS) && OFFERINGS.length > 0) {
      const offering = OFFERINGS.find((o) => {
        const { id } = params;
        return o.id === parseInt(id);
      });
      setState({ currentOffering: offering });
    }
  }, [OFFERINGS, params]);

  const emailModalSend = async (email) => {
    logger.debug(LOG_PREFIX, ".emailModalSend()");
    setState({ isLoading: true });
    await prepMessageSend(
      CLIENT.email,
      emailOfferingList,
      COMPANY,
      CLIENT.account
    ).then(() => {
      setState({ sentOfferings: true });
      setTimeout(() => {
        setState({
          sentOfferings: false,
          emailModal: false,
          emailOfferingList: [],
          isLoading: false,
        });
      }, 2500);
    });
  };

  // Show loading state if data isn't ready
  if (!Array.isArray(OFFERINGS) || OFFERINGS.length === 0) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        Loading offerings...
      </div>
    );
  }

  if (currentOffering) {
    return (
      <div className="offer-wrapper">
        <OfferingSidebar currentOfferingId={currentOffering.id} {...props} />
        <OfferingContentContainer
          offering={currentOffering}
          toggleModal={() => {
            setState({ emailModal: !emailModal });
          }}
          {...props}
        />

        {emailModal && (
          <EmailModal
            customerEmail={CLIENT.email}
            onSend={emailModalSend}
            onClear={() => {
              setState({ emailOfferingList: [] });
            }}
            onAdd={() => {
              setState({
                emailOfferingList: [
                  ...new Set([...emailOfferingList, currentOffering]),
                ],
              });
            }}
            onClick={(name) => {
              const id = emailOfferingList.find(
                (x) => x.json_data.nickname === name || x.sales_option === name
              ).id;
              navigate(`/offering/${id}`, { replace: true });
            }}
            onDelete={(name) => {
              setState({
                emailOfferingList: emailOfferingList.filter(
                  (x) =>
                    x.json_data.nickname !== name && x.sales_option !== name
                ),
              });
            }}
            sentOfferings={sentOfferings}
            sendDisabled={emailOfferingList.length < 1 || isLoading}
            toggleClosed={() => {
              setState({ emailModal: false });
            }}
            offeringNames={emailOfferingList.map(
              (o) => o.json_data.nickname || o.sales_option
            )}
          />
        )}
      </div>
    );
  } else {
    // Navigate to first offering if current one isn't found
    navigate(`/offering/${OFFERINGS[0].id}`, { replace: true });
    return null;
  }
};

export default Offering;
